import React, { useState } from 'react';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import Form from '../../../../adminpanel/components/commonComponents/Form.v2';
import LoadingComponent from '../../../../adminpanel/components/commonComponents/LoadingComponent';
import ModalComponent from "../../../../adminpanel/components/commonComponents/ModalComponent";
import { ButtonComponent } from '../../../components/commonComponents/UIComponent';
import StepThreeTable from './StepThreeTable';
const numberOfRecords = 5

const filterFormVar = {
    "entireData": {
        "name": "entireData", "label": "Pull Type", "type": "dropdown", "text_value": "", "options": [
            { "name": "Selected Period", "value": "false" },
            { "name": "Entire Data", "value": "true" }
        ], "requiredFlag": true
    },
    "dateColumns": {
        "name": "dateColumns", "label": "Date Columns to Filter/ Default Date", "type": "dropdown", "text_value": "", "options": [], "requiredFlag": false, "disabled": true
    },
    "startDate": {
        "name": "startDate", "label": "Start Date", "type": "date", "text_value": "", "requiredFlag": false, "disabled": true
    },
    "endDate": {
        "name": "endDate", "label": "End Date", "type": "date", "text_value": "", "requiredFlag": false, "disabled": true
    },
    "min_split": {
        "name": "min_split", "label": "Min Split", "type": "dropdown", "options": [
            { "name": "Select Option", "value": "" },
            { "name": "Day", "value": "day" },
            { "name": "Week", "value": "week" },
            { "name": "Month", "value": "month" },
            { "name": "Year", "value": "year" }
        ], "requiredFlag": false, "disabled": true
    },
    "data_split": {
        "name": "data_split", "label": "Data Split", "type": "dropdown", "options": [
            { "name": "Select Option", "value": "" },
            { "name": "1", "value": "1" }, { "name": "2", "value": "2" }, { "name": "3", "value": "3" }, { "name": "4", "value": "4" }, { "name": "5", "value": "5" }, { "name": "6", "value": "6" }, { "name": "7", "value": "7" }, { "name": "8", "value": "8" }, { "name": "9", "value": "9" }, { "name": "10", "value": "10" }, { "name": "12", "value": "12" }
        ], "requiredFlag": false, "disabled": true
    },
    "limit": {
        "name": "limit", "label": "Limit", "type": "hide", "requiredFlag": false
    },
    "queryFilterData": {
        "name": "queryFilterData", "label": "Filter Table with Table Data", "type": "text", "text_value": "", "requiredFlag": false
    },
    "columnName": {
        "name": "columnName", "label": "Selected Columns", "multiple": true, "type": "dropdown", "options": [], "requiredFlag": false
    }
    // "columnFilterData": {
    //     "name": "columnFilterData", "label": "Normalize Table with Attributes", "type": "dropdown", "text_value": "", "options": dateOptions.modalData, requiredFlag: true
    // },
}

var allColumnArrayValues = [], selectedColumnArrayValues = []

const TablePreview = ({ authData, selectedRows, selectedCount, initialData, setConnectionType, setSelectedRows }) => {

    const [previewData, setpreviewData] = useState({});
    const [loadStatus, setloadStatus] = useState(false);
    const [modalFormData, setModalFormData] = useState({});
    const [formData, setformData] = useState({});

    const handlePreviewButton = () => {
        if (selectedRows.length > 0) {
            let params = {
                siteId: authData.siteId,
            }

            let selectedTable = [];
            let sampleFormData = {};
            selectedRows.map(individualRow => {
                selectedTable.push({ "tableName": `${individualRow.clientDBName}.${individualRow.clientTableName}`, limit: numberOfRecords });
                sampleFormData[`${individualRow.clientDBName}.${individualRow.clientTableName}`] = { validation: false, clientDBName: `${individualRow.clientDBName}`, clientTableName: `${individualRow.clientTableName}` };
            });

            let postBody = {
                "connectionId": initialData.connectionId,
                "tableArray": selectedTable
            }
            setloadStatus(true);
            setformData(sampleFormData);

            CallAPI('post', '/app/fetch_preview_data', postBody, params, 0, function (response) {
                if (response.status === true) {
                    let data = response.information;
                    setpreviewData(data);
                }
                setloadStatus(false);
            }, authData)

        } else if (selectedRows.length === 0) {
            alert("Please, select a table which you want to preview.");
        }
    }

    const filterButton = (eventType, tableName) => {
        allColumnArrayValues = []
        if (eventType === "filter") {
            let tempDateData = [{ "name": "Select Date Column", "value": "" }];
            let tempColumnData = [];
            let dateColumn = false;
            let disabled = true;
            let tempFormVar = {};
            tempFormVar['tableName'] = tableName.tableName;
            tempFormVar['modalData'] = JSON.parse(JSON.stringify(filterFormVar));

            if (previewData[tableName.tableName].columnArray && Object.values(previewData[tableName.tableName].columnArray).length > 0) {
                Object.values(previewData[tableName.tableName].columnArray).map(innerData => {
                    tempColumnData.push({ "name": `${innerData.raw_column_name} - ${innerData.data_type}`, "value": innerData.raw_column_name })
                    allColumnArrayValues.push(innerData.raw_column_name)
                });
                tempFormVar['modalData']['columnName']['options'] = tempColumnData;
                tempFormVar['modalData']['columnName']['text_value'] = formData[tableName.tableName]['columnName'] ? formData[tableName.tableName]['columnName'] : allColumnArrayValues;
            }

            if (previewData[tableName.tableName].dateColumn && Object.keys(previewData[tableName.tableName].dateColumn).length > 0) {
                dateColumn = true;
                disabled = false;
                Object.keys(previewData[tableName.tableName].dateColumn).map(individualDate => {
                    tempDateData.push({ "name": individualDate, "value": individualDate })
                });
                tempFormVar['modalData']['dateColumns']['options'] = tempDateData;

                tempFormVar['modalData']['dateColumns']['disabled'] = disabled;
                tempFormVar['modalData']['dateColumns']['requiredFlag'] = dateColumn;
                tempFormVar['modalData']['startDate'] ? tempFormVar['modalData']['startDate']['disabled'] = disabled : null;
                tempFormVar['modalData']['startDate'] ? tempFormVar['modalData']['startDate']['requiredFlag'] = dateColumn : null;
                tempFormVar['modalData']['endDate'] ? tempFormVar['modalData']['endDate']['disabled'] = disabled : null;
                tempFormVar['modalData']['endDate'] ? tempFormVar['modalData']['endDate']['requiredFlag'] = dateColumn : null;
                tempFormVar['modalData']['min_split'] ? tempFormVar['modalData']['min_split']['disabled'] = disabled : null;
                tempFormVar['modalData']['data_split'] ? tempFormVar['modalData']['data_split']['disabled'] = disabled : null;
                if (formData[tableName.tableName] && formData[tableName.tableName].validation === true) {
                    tempFormVar['modalData']['entireData']['text_value'] = formData[tableName.tableName]['entireData'];
                    if (formData[tableName.tableName].entireData === "false") {
                        tempFormVar['modalData']['dateColumns']['text_value'] = formData[tableName.tableName]['dateColumns'];
                        tempFormVar['modalData']['startDate']['text_value'] = formData[tableName.tableName]['startDate'];
                        tempFormVar['modalData']['endDate']['text_value'] = formData[tableName.tableName]['endDate'];
                        tempFormVar['modalData']['min_split']['text_value'] = formData[tableName.tableName]['min_split'];
                        tempFormVar['modalData']['data_split']['text_value'] = formData[tableName.tableName]['data_split'];
                    } else if (formData[tableName.tableName].entireData === "true") {
                        tempFormVar['modalData']['dateColumns']['type'] = 'hide';
                        tempFormVar['modalData']['startDate']['type'] = 'hide';
                        tempFormVar['modalData']['endDate']['type'] = 'hide';
                        tempFormVar['modalData']['data_split']['type'] = 'hide';
                        tempFormVar['modalData']['min_split']['type'] = 'hide';
                        tempFormVar['modalData']['limit']['type'] = 'number';
                        tempFormVar['modalData']['limit']['text_value'] = formData[tableName.tableName]['limit'];
                    }
                    tempFormVar['modalData']['queryFilterData']['text_value'] = formData[tableName.tableName]['queryFilterData'];
                } else {
                    tempFormVar['modalData']['dateColumns']['text_value'] = '';
                    tempFormVar['modalData']['startDate']['text_value'] = '';
                    tempFormVar['modalData']['endDate']['text_value'] = '';
                    tempFormVar['modalData']['min_split']['text_value'] = '';
                    tempFormVar['modalData']['data_split']['text_value'] = '';
                    tempFormVar['modalData']['queryFilterData']['text_value'] = '';
                }
            } else {
                tempFormVar['modalData']['entireData']['text_value'] = "true";
                tempFormVar['modalData']['dateColumns']['type'] = 'hide';
                tempFormVar['modalData']['startDate']['type'] = 'hide';
                tempFormVar['modalData']['endDate']['type'] = 'hide';
                tempFormVar['modalData']['data_split']['type'] = 'hide';
                tempFormVar['modalData']['min_split']['type'] = 'hide';
                tempFormVar['modalData']['limit']['type'] = 'number';
                tempFormVar['modalData']['limit']['text_value'] = formData[tableName.tableName]['limit'];
                tempFormVar['modalData']['queryFilterData']['text_value'] = formData[tableName.tableName]['queryFilterData'];
            }
            setModalFormData(tempFormVar);
            setTimeout(() => {
                jQuery("#addFilterModal").modal('toggle');
            }, 10);
        }
    }

    const handleDropDown = (e) => {
        let tempFormData = modalFormData['modalData'];
        if (e.target.name) {
            if (tempFormData[e.target.name].multiple) {
                tempFormData[e.target.name].text_value = $(`#${e.target.name}_form_data`).val();
            }
            else tempFormData[e.target.name].text_value = e.target.value;
        }
        if (e.target.name === 'entireData') {
            switch (e.target.value) {
                case "true":
                    tempFormData['dateColumns']['type'] = 'hide';
                    tempFormData['startDate']['type'] = "hide";
                    tempFormData['endDate']['type'] = "hide";
                    tempFormData['min_split']['type'] = 'hide';
                    tempFormData['data_split']['type'] = 'hide';
                    tempFormData['limit']['type'] = 'number'
                    break;
                case "false":
                    tempFormData['dateColumns']['type'] = 'dropdown';
                    tempFormData['startDate']['type'] = "date";
                    tempFormData['endDate']['type'] = "date";
                    tempFormData['min_split']['type'] = 'dropdown';
                    tempFormData['data_split']['type'] = 'dropdown';
                    tempFormData['limit']['type'] = 'hide'
                    break;
            }
        } else if (e.target.name === 'min_split') {
            if (e.target.value !== '') {
                tempFormData['data_split']['requiredFlag'] = true
            } else tempFormData['data_split']['requiredFlag'] = false
        } else if (e.target.name === 'data_split') {
            if (e.target.value !== '') {
                tempFormData['min_split']['requiredFlag'] = true
            } else tempFormData['min_split']['requiredFlag'] = false
        } else if (e.target.name === 'dateColumns') {
            if (e.target.value) {
                tempFormData['startDate']['text_value'] = previewData[modalFormData.tableName].dateColumn[e.target.value].minDate ? previewData[modalFormData.tableName].dateColumn[e.target.value].minDate.split(' ')[0] : ''
                tempFormData['endDate']['text_value'] = previewData[modalFormData.tableName].dateColumn[e.target.value].maxDate ? previewData[modalFormData.tableName].dateColumn[e.target.value].maxDate.split(' ')[0] : ''
            } else {
                tempFormData['startDate']['text_value'] = ''
                tempFormData['endDate']['text_value'] = ''
            }
        }
        let tempModal = modalConfig['addFilterModal'];
        tempModal['formKey'] = `editRangeFilter${Math.floor(Math.random() * 10)}`;
        setModalFormData({ ...modalFormData, modalData: tempFormData });
    }

    const filterSubmit = (event) => {
        let tempFormData = { ...formData };
        let formDataCopy = { ...formData };
        tempFormData[modalFormData['tableName']] = {}
        $("#editRangeFilter").serializeArray().map(function (innerData) {
            if (innerData.name === 'columnName' && innerData.value) {
                selectedColumnArrayValues.push(innerData.value)
            } else tempFormData[modalFormData['tableName']][innerData.name] = innerData.value;
        })
        if (selectedColumnArrayValues.length === allColumnArrayValues.length) {
            tempFormData[modalFormData['tableName']]['columnName'] = ''
        } else tempFormData[modalFormData['tableName']]['columnName'] = selectedColumnArrayValues

        tempFormData[modalFormData['tableName']]['validation'] = true;
        tempFormData[modalFormData['tableName']]['orginalDateColumn'] = previewData[modalFormData['tableName']].dateColumn;
        tempFormData[modalFormData['tableName']]['clientDBName'] = formDataCopy[modalFormData['tableName']].clientDBName;
        tempFormData[modalFormData['tableName']]['clientTableName'] = formDataCopy[modalFormData['tableName']].clientTableName;
        setformData(tempFormData);
        selectedColumnArrayValues = []
        jQuery("#addFilterModal").modal('toggle');
        event.preventDefault();
    }

    const handleNextButton = () => {
        setConnectionType({ "connectionId": initialData.connectionId, selectedStep: 4, "connection_type": initialData.connection_type, "selectedTables": formData })
    }

    const filter_form = Object.keys(modalFormData).length > 0 ? <Form label_array={modalFormData['modalData']} handle_form_drop_down={handleDropDown} handleForm={handleDropDown} /> : null;
    let title = <>{`Edit Range`}<span>({`${modalFormData.tableName}`})</span></>;
    const modalConfig = filter_form ? {
        "addFilterModal": {
            "id": "addFilterModal", "form_id": "editRangeFilter", "form_name": "editRange", "title": title, "body": filter_form, "button_name": "Apply", "display": true, buttonType: "submit", "formKey": `editRangeFilter${Math.floor(Math.random() * 10)}`
        }
    } : null;

    let previewTableButton = { "name": "Preview", "event": handlePreviewButton ,"className": "btn btn-primary btn-sm text-white float-right mg-l-5"};
    let disable = false;
    Object.keys(formData).map(function (innerData) {
        if (formData[innerData].validation === false && disable === false) { disable = true; };
    })
    let nextStepButton = { "className": `btn btn-primary btn-sm text-white float-right mg-l-5 ${disable === false && Object.keys(formData).length > 0 ? null : "disabled"}`, "name": "Next", "type": "add", "icon": "play", "event": handleNextButton };
    let isMobile  = jQuery(window).width() <= mobile_width;

    return (
        <>
            <div className="card-header ht-100">
                <div className={isMobile ? 'd-flex align-items-center':''}>
                    <p className="mg-r-10 d-inline">
                        {selectedCount <= 1 ? `${selectedCount} table selected for preview.` : `${selectedCount} tables selected for preview.`}
                    </p>
                    <ButtonComponent buttonData={previewTableButton} ></ButtonComponent>
                    <ButtonComponent buttonData={nextStepButton} ></ButtonComponent>
                </div>
                <p className="bootstrap-tagsinput">
                    {selectedRows.map(function (innerData) {
                        return <p className="tag label label-info">
                            {`${innerData.clientDBName}.${innerData.clientTableName}`}
                            {/* <span data-role="remove" onClick={() => removeEvent(innerData.clientTableName)}></span> */}
                        </p>
                    })}
                </p>
            </div>
            <div className="card-body">
                {loadStatus == true ? <LoadingComponent /> : <StepThreeTable previewData={previewData} filterButton={filterButton} formData={formData} />}
                {modalConfig ? <ModalComponent modalConfig={modalConfig["addFilterModal"]} formSubmit={filterSubmit} /> : null}
            </div>
        </>
    )
}
export default TablePreview;